import React from 'react';
import { Button } from 'react-bootstrap';

const CampaignCard = ({ item, onDetails }) => {
    const getStatusClass = (status) => {
        switch (status?.toLowerCase()) {
            case 'active':
            case 'ativa':
            case 'published':
                return 'status-active';
            case 'scheduled':
            case 'agendada':
                return 'status-scheduled';
            default:
                return 'status-expired';
        }
    };

    const getStatusIcon = (status) => {
        switch (status?.toLowerCase()) {
            case 'active':
            case 'ativa':
            case 'published':
                return 'fa-solid fa-circle-check';
            case 'scheduled':
            case 'agendada':
                return 'fa-solid fa-clock';
            default:
                return 'fa-solid fa-box-archive';
        }
    };

    return (
        <div className="col-12 col-md-6 col-lg-4 p-2 mb-3">
            <div className="campaign-card">
                <div className="d-flex justify-content-between align-items-start mb-3">
                    <span className={`campaign-status ${getStatusClass(item.status)}`}>
                        <i className={getStatusIcon(item.status)}></i>
                        {item.status || 'Finalizada'}
                    </span>
                    <div className="text-muted small">
                        <i className="fa-regular fa-calendar me-1"></i>
                        {item.date_formated || item.release_date || item.data}
                    </div>
                </div>

                <h3 className="title">{item.name || item.nome}</h3>

                <div className="mt-auto pt-3 border-top border-secondary border-opacity-10">
                    <div className="row g-2 campaign-actions">
                        <div className="col-12">
                            <button
                                onClick={() => onDetails(item.id)}
                                className="btn-action btn-campaign-secondary"
                            >
                                <i className="fa-solid fa-magnifying-glass-chart"></i>
                                Ver Detalhes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CampaignCard;
